export function formatPhone(val) {
  let raw = val.replace(/\D/g,'');
  if (raw.startsWith('90')) raw = raw.slice(2);
  else if (raw.startsWith('0')) raw = raw.slice(1);
  raw = raw.slice(0,10);
  if (!raw) return '';
  if (raw.length<=3) return '+90 ('+raw;
  if (raw.length<=6) return '+90 ('+raw.slice(0,3)+') '+raw.slice(3);
  if (raw.length<=8) return '+90 ('+raw.slice(0,3)+') '+raw.slice(3,6)+' '+raw.slice(6);
  return '+90 ('+raw.slice(0,3)+') '+raw.slice(3,6)+' '+raw.slice(6,8)+' '+raw.slice(8);
}

export function capitalizeWords(val) {
  return val.replace(/\S+/g, w => w.charAt(0).toLocaleUpperCase('tr-TR') + w.slice(1));
}

export function fmtD(km){return km<1?Math.round(km*1000)+' m':km.toFixed(1)+' km';}
